export default {
  udcStepPassed: [
    {
      type: 'boolean',
      required: true,
      validator: (rule, value) => value === true,
    },
  ],
};
